<template>
  <div>
    <div class="pa-5 text-center" style="min-height: 150px">
      <v-icon size="50" class="pb-1 align-self-center" color="primary">
        {{ iconCustom }}
      </v-icon>
      <small
        class="pt-3 primary--text small d-block text-center font-weight-bold"
      >
        {{ betText }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    betText: { type: String, default: '', required: false },
    iconCustom: { type: String, default: '', required: false }
  }
}
</script>
